import React from 'react';
import { Dialog } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import CloseIcon from '@material-ui/icons/Close';
import './activities-dialog.scss';
import i18n from '../../i18n';
import MobileStepper from '@material-ui/core/MobileStepper';
import ReactMarkdown from 'react-markdown';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export function ActivitiesDialog({ visible, onClose, images, type, description }: Props) {
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = images.length;

    return <Dialog
        open={visible}
        className={'activities-dialog'}
        onBackdropClick={() => { onClose(); }}
        fullWidth
    >
        <div className='activities-dialog-head'>
            <span className='activities-dialog-title'>{i18n.t('restaurant_info_page_text_my_activities')}</span>
            <CloseIcon className='activities-dialog-close' onClick={() => { onClose(); }} />
        </div>

        {type === 'image' ? <>
            <AutoPlaySwipeableViews
                index={activeStep}
                onChangeIndex={(value) => { setActiveStep(value || 0) }}
                enableMouseEvents
                className='swipeable-page'
                onClick={(e) => { e.stopPropagation(); }}
            >
                {images?.map((item, index) => (
                    <div key={index} className='imgbox'>
                        <img className='itemimg' src={item.url} alt='' />
                    </div>
                ))}
            </AutoPlaySwipeableViews>
            <div className='Stepperdots-box'>
                <MobileStepper
                    className='Stepperdots'
                    steps={maxSteps}
                    position='static'
                    variant='dots'
                    activeStep={activeStep}
                    nextButton={null}
                    backButton={null}
                />
            </div>
        </>
            :
            <ReactMarkdown className='markdown activity-markdown' source={description} escapeHtml={false} />}



    </Dialog>
}

type Props = {
    visible: boolean;
    onClose: () => void;
    images: { url: string }[];
    type: 'text' | 'image';
    description: string;
}